'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class;

// Utils


// Actions


// Components


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _fileValidator = require('../../utils/services/file/fileValidator');

var _dontUpdateForKeys = require('../../utils/milanoteRecompose/dontUpdateForKeys');

var _dontUpdateForKeys2 = _interopRequireDefault(_dontUpdateForKeys);

var _gridSizeSelector = require('../../utils/grid/gridSizeSelector');

var _analytics = require('../../analytics');

var _elementAttachmentActions = require('../../element/elementAttachmentActions');

var _elementAttachmentActions2 = require('../elementAttachmentActions');

var _Image = require('./Image');

var _Image2 = _interopRequireDefault(_Image);

var _ColumnOnDropDropTarget = require('../column/ColumnOnDropDropTarget');

var _ColumnOnDropDropTarget2 = _interopRequireDefault(_ColumnOnDropDropTarget);

var _columnOnDropConnectDropTarget = require('../column/columnOnDropConnectDropTarget');

var _columnOnDropConnectDropTarget2 = _interopRequireDefault(_columnOnDropConnectDropTarget);

var _captionContainerDecorator = require('../../components/caption/captionContainerDecorator');

var _captionContainerDecorator2 = _interopRequireDefault(_captionContainerDecorator);

var _imageFileDropTargetDecorator = require('../../components/tools/images/imageFileDropTargetDecorator');

var _imageFileDropTargetDecorator2 = _interopRequireDefault(_imageFileDropTargetDecorator);

var _elementLineEdgeDropTarget = require('../line/elementLineEdgeDropTarget');

var _elementLineEdgeDropTarget2 = _interopRequireDefault(_elementLineEdgeDropTarget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// File drop functionality
var handleCanDrop = function handleCanDrop(props, monitor, component) {
    return !props.hasImage;
};
var ImageWithFileDrop = function ImageWithFileDrop(props) {
    return _react2.default.createElement(_Image2.default, props);
};
ImageWithFileDrop = (0, _imageFileDropTargetDecorator2.default)({ canDrop: handleCanDrop })(ImageWithFileDrop);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchUploadImage: function dispatchUploadImage(elementID, file) {
            var validationError = (0, _fileValidator.validateImageFile)(file);
            if (validationError) {
                dispatch((0, _elementAttachmentActions2.errorUploadingElementAttachment)({
                    id: elementID,
                    error: validationError
                }));
                return;
            }
            return dispatch((0, _elementAttachmentActions.uploadAttachment)({ id: elementID, file: file }));
        }
    };
};

var ImageContainer = (_dec = (0, _reactRedux.connect)(_gridSizeSelector.gridSizeSelector, mapDispatchToProps), _dec2 = (0, _dontUpdateForKeys2.default)(['dragModifierKeys', 'canDrop']), _dec(_class = (0, _elementLineEdgeDropTarget2.default)(_class = (0, _ColumnOnDropDropTarget2.default)(_class = _dec2(_class = (0, _captionContainerDecorator2.default)(_class = function (_React$Component) {
    _inherits(ImageContainer, _React$Component);

    function ImageContainer() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ImageContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageContainer.__proto__ || Object.getPrototypeOf(ImageContainer)).call.apply(_ref, [this].concat(args))), _this), _this.setElementSize = function (size) {
            var setElementSize = _this.props.setElementSize;

            (0, _analytics.analyticsEvent)('resized-image');
            return setElementSize(size);
        }, _this.handleKey = function (event) {
            if (!_this.props.isSelected) return;
            _this.props.captionKeyHandler(event, _this.props);
        }, _this.uploadImage = function (file) {
            var _this$props = _this.props,
                dispatchUploadImage = _this$props.dispatchUploadImage,
                element = _this$props.element;

            dispatchUploadImage(element.get('id'), file);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ImageContainer, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                connectLineEdgeDropTarget = _props.connectLineEdgeDropTarget,
                inList = _props.inList;


            var lineEdgeConnector = connectLineEdgeDropTarget && !inList ? connectLineEdgeDropTarget : _lodash.identity;

            return (0, _columnOnDropConnectDropTarget2.default)(this.props, lineEdgeConnector(_react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(ImageWithFileDrop, _extends({}, this.props, {
                    uploadImage: this.uploadImage,
                    handleKey: this.handleKey,
                    setElementSize: this.setElementSize }))
            )));
        }
    }]);

    return ImageContainer;
}(_react2.default.Component)) || _class) || _class) || _class) || _class) || _class);


ImageContainer.propTypes = {
    element: _propTypes2.default.object.isRequired,
    connectDropTarget: _propTypes2.default.func,
    connectLineEdgeDropTarget: _propTypes2.default.func,
    isSelected: _propTypes2.default.bool,
    captionKeyHandler: _propTypes2.default.func,
    dispatchCleanElementAttachment: _propTypes2.default.func,
    dispatchUpdateElement: _propTypes2.default.func.isRequired,
    dispatchUploadImage: _propTypes2.default.func,
    inList: _propTypes2.default.string,
    setElementSize: _propTypes2.default.func
};

exports.default = ImageContainer;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/image/ImageContainer.js
// module id = 1979
// module chunks = 0